export function buildCapexAccountByIdQueryV1(workspaceId: number, strategyId: string, capexId: string)
{
    return {
        '$type': 'TCh.Domain.Quest.Financials.Capex.Queries.CapexAccountByIdQueryV1, TCh.Domain.Quest',
        'WorkspaceId': workspaceId,
        'StrategyId': strategyId,
        'CapexId': capexId,
    }
}

export function buildCapexAccountsByStrategyIdQueryV1(workspaceId: number, strategyId: string)
{
    return {
        '$type': 'TCh.Domain.Quest.Financials.Capex.Queries.CapexAccountsByStrategyIdQueryV1, TCh.Domain.Quest',
        'WorkspaceId': workspaceId,
        'StrategyId': strategyId,
    }
}

export function buildCapexAccountsByPortfolioIdQueryV1(workspaceId: number, portfolioId: string)
{
    return {
        '$type': 'TCh.Domain.Quest.Financials.Capex.Queries.CapexAccountsByPortfolioIdQueryV1, TCh.Domain.Quest',
        'WorkspaceId': workspaceId,
        'PortfolioId': portfolioId
    }
}
